var exports = {
  "id": "x93eb46d8--6d29b7--discount",
  "_R": "x93eb46d8--6d29b7--original-price",
  "ip": "x93eb46d8--6d29b7--discount-percent",
  "ff": "x93eb46d8--6d29b7--discount--compact",
};

module.exports = exports;
